import { EPaymentPlan } from '@if/core/types';
const REGULAR_PLAN_ID = EPaymentPlan.RegularDailyInterests;
const isPromoOption = (option) => option.paymentPlanId !== REGULAR_PLAN_ID;
// Lowest interest = the lowest promo rate among the priced options; when several terms or plans share it, the lowest
// monthly payment wins. Lowest payment = the regular plan at its longest term. The options come already priced by the
// backend, so nothing is recalculated here.
export function getPlanChoices(options) {
    const { lowestInterest, longestRegular } = options.reduce((best, option) => {
        if (isPromoOption(option)) {
            const current = best.lowestInterest;
            const isBetter = current === null ||
                option.interestRate < current.interestRate ||
                (option.interestRate === current.interestRate && option.monthlyPayment < current.monthlyPayment);
            return isBetter ? { ...best, lowestInterest: option } : best;
        }
        return best.longestRegular === null || option.term > best.longestRegular.term ? { ...best, longestRegular: option } : best;
    }, { lowestInterest: null, longestRegular: null });
    if (!lowestInterest || !longestRegular)
        return null;
    return {
        lowestInterest: {
            term: lowestInterest.term,
            paymentPlanId: lowestInterest.paymentPlanId,
            interestRate: lowestInterest.interestRate,
            rateDurationMonths: lowestInterest.promoDurationMonths ?? lowestInterest.term,
            monthlyPayment: lowestInterest.monthlyPayment,
        },
        lowestPayment: {
            term: longestRegular.term,
            paymentPlanId: longestRegular.paymentPlanId,
            interestRate: longestRegular.interestRate,
            rateDurationMonths: longestRegular.term,
            monthlyPayment: longestRegular.monthlyPayment,
        },
    };
}
